export default __webpack_public_path__ + "static/media/team_settings.67578e30.png";